import flow from 'lodash/flow';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import connectWithFailureState from 'src/common/decorators/connectWithFailureState';
import css from 'src/common/styles/common.module.scss';
import { userPathname } from 'src/common/utils/guideItem/getGuideItemPathname';
import ContainerItemsLoader from '../containerItems/ContainerItemsLoader';
import SeoHelmet from '../SeoHelmet';
import UserHeader from '../shared/UserHeader';

import canonicalLinkObj from '../utils/canonicalLinkObj';

// eslint-disable-next-line max-len
const descriptionSuffix =
  'Listen free online to Sports, Music, Talk, News, NFL, MLB, NBA, NHL, Audiobooks & Podcasts.';
function getMetaDescription(title) {
  return `Join ${title} on TuneIn. ${descriptionSuffix}`;
}

function getUser(state, props) {
  return state.users[props.userName];
}

export function User({ user = { id: '', title: '', userName: '' }, breakpoint, routeProps }) {
  const { id, title, userName, isFetching, containers } = user;

  return (
    <div className={css.contentContainer}>
      <SeoHelmet
        title={title}
        description={getMetaDescription(title)}
        keywords={[title, 'online radio']}
        links={[canonicalLinkObj(userPathname(userName))]}
      />
      <div>
        <UserHeader {...user} />
        <ContainerItemsLoader
          selectedContentId={id}
          items={containers}
          isFetching={isFetching}
          breakpoint={breakpoint}
          routeProps={routeProps}
        />
      </div>
    </div>
  );
}

User.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
    containers: PropTypes.array,
  }),
  breakpoint: PropTypes.number.isRequired,
  routeProps: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  return {
    user: getUser(state, props),
  };
}

export default flow(connectWithFailureState(getUser), connect(mapStateToProps))(User);
